function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
Ways of selecting features:
1) By id
- clicking feature on map
- clicking feature row in object data table/grid
2) Through filter by property values
- filter icon on object data table/grid (WFSSetPropertyFilter?)
3) Using geometry to select features
- featuredata2 selection tool (WFSSetFilter)
 -> this could be changed so that features that fit the geometry are detected outside this service and selection is made with ids
*/

/**
 * Compares two arrays to see if the contents match
 * @param {String[]} previous previous selection
 * @param {String[]} current current selection
 * @returns true if the content is the same
 */
var isSameContent = function isSameContent() {
  var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (current.length !== previous.length) {
    // different amount selected -> notify
    return false;
  } else if (previous.length && current.length) {
    // if there are selected features but size didn't change -> compare content
    return current.every(function (item) {
      return previous.includes(item);
    });
  }
  return true;
};
export var QNAME = 'Oskari.mapframework.service.VectorFeatureSelectionService';

/**
 * Responsible for tracking selected features that are set by feature id/layer or filter that selected features from layers.
 */
export var VectorFeatureSelectionService = /*#__PURE__*/function () {
  function VectorFeatureSelectionService(sandbox) {
    _classCallCheck(this, VectorFeatureSelectionService);
    this.__name = 'VectorFeatureSelectionService';
    this._featureSources = [];
    this._selectedFeaturesByLayer = {};
    this._filtersByLayer = {};
    this._sandbox = sandbox;
    sandbox.registerForEventByName(this, 'AfterMapLayerRemoveEvent');
    Oskari.makeObservable(this);
  }
  return _createClass(VectorFeatureSelectionService, [{
    key: "addSelectedFeature",
    value: function addSelectedFeature(layerId, id) {
      if (typeof layerId === 'undefined') {
        throw new Error('LayerId is required');
      }
      if (typeof id === 'undefined') {
        throw new Error('Feature id is required');
      }
      var features = this._selectedFeaturesByLayer[layerId];
      if (!features) {
        features = [];
        this._selectedFeaturesByLayer[layerId] = features;
      }
      if (!features.includes(id)) {
        var previousSelection = this.getSelectedFeatureIdsByLayer(layerId);
        features.push(id);
        this.__notifySelectionChange(layerId, previousSelection);
      }
    }
  }, {
    key: "setSelectedFeatureIds",
    value: function setSelectedFeatureIds(layerId, idList) {
      if (typeof layerId === 'undefined') {
        throw new Error('LayerId is required');
      }
      if (!Array.isArray(idList)) {
        throw new Error('idList should be an Array');
      }
      var previousSelection = this.getSelectedFeatureIdsByLayer(layerId);
      this._selectedFeaturesByLayer[layerId] = idList.slice(0);
      var currentSelection = this.getSelectedFeatureIdsByLayer(layerId);
      if (!isSameContent(previousSelection, currentSelection)) {
        this.__notifySelectionChange(layerId, previousSelection);
      }
    }
  }, {
    key: "removeSelection",
    value: function removeSelection(layerId, id) {
      var _this = this;
      if (typeof layerId === 'undefined' && typeof id === 'undefined') {
        // full reset
        Object.keys(this._selectedFeaturesByLayer).forEach(function (layerId) {
          return _this.removeSelection(layerId);
        });
        return;
      }
      if (typeof layerId === 'undefined' && typeof id !== 'undefined') {
        // require layer id if feature id is requested
        throw new Error('LayerId is required');
      }
      if (typeof layerId !== 'undefined' && typeof id === 'undefined') {
        // clear all selected from single layer
        var _previousSelection = this.getSelectedFeatureIdsByLayer(layerId);
        this._selectedFeaturesByLayer[layerId] = [];
        if (_previousSelection.length) {
          this.__notifySelectionChange(layerId, _previousSelection);
        }
        return;
      }
      var previousSelection = this.getSelectedFeatureIdsByLayer(layerId);
      this._selectedFeaturesByLayer[layerId] = previousSelection.filter(function (selectedId) {
        return id !== selectedId;
      });
      if (previousSelection.length !== this._selectedFeaturesByLayer[layerId].length) {
        this.__notifySelectionChange(layerId, previousSelection);
      }
    }
  }, {
    key: "toggleFeatureSelection",
    value: function toggleFeatureSelection(layerId, featureId) {
      var selection = this.getSelectedFeatureIdsByLayer(layerId);
      if (selection.includes(featureId)) {
        this.removeSelection(layerId, featureId);
      } else {
        this.addSelectedFeature(layerId, featureId);
      }
    }
  }, {
    key: "getSelectedFeatureIdsByLayer",
    value: function getSelectedFeatureIdsByLayer(layerId) {
      if (typeof layerId === 'undefined') {
        return [];
      }
      var features = this._selectedFeaturesByLayer[layerId];
      if (features) {
        return features.slice(0);
      }
      return [];
    }
  }, {
    key: "getLayerIdsWithSelections",
    value: function getLayerIdsWithSelections() {
      var _this2 = this;
      // filter ids with empty arrays and convert to Number if possible
      return Object.keys(this._selectedFeaturesByLayer).filter(function (id) {
        return _this2._selectedFeaturesByLayer[id].length;
      }).map(function (layerId) {
        return isNaN(layerId) ? layerId : Number(layerId);
      });
    }
    /* ****************************************
     * Might be worth it to get actual features (as GeoJSON) through this service instead of just ids
     * ****************************************
     */
    /*
    registerVectorFeatureSource(source) {
        if (typeof source === 'undefined') {
            throw new Error('Tried registering undefined source');
        }
        if (typeof source.getFeatureFromLayer !== 'function') {
            // for getting GeoJSON for feature id
            throw new Error('Source needs to implement getFeatureFromLayer()');
        }
        if (typeof source.getFeatures !== 'function') {
            // for filtering
            throw new Error('Source needs to implement getFeatures()');
        }
        this._featureSources.push(source);
    }
    getSelectedFeaturesByLayer (layerId) {
        if (typeof layerId === 'undefined') {
           return [];
        }
        const featuresIds = this.getSelectedFeatureIdsByLayer(layerId);
        const features = featuresIds
            .map(id => this.__findFeatureFromSources(layerId, id))
            .filter(item => !!item);
        return features;
    }
    __findFeatureFromSources (layerId, id) {
        let feature;
        this._featureSources.forEach(source => {
            if (!feature) {
                // only search sources if we haven't found it already
                feature = source.getFeatureFromLayer(layerId, id);
            }
        });
        return feature;
    }
    */
    /* ****************************************
     * Filter stuff - the idea is that selected features could change when
     *    map moves as more features are loaded in to viewport (and others are removed from it)
     *  NOTE! Not sure if this service should react to map moving or just store the filters
     * ****************************************
     */
    /*
    setSelectionFilterForLayer (layerId, filter) {
        if (typeof layerId === 'undefined') {
            throw new Error('LayerId is required');
        }
        const currentFeatures = this.__getFeaturesIdsForFilter(layerId);
        this._filtersByLayer[layerId] = filter;
        const updatedFeatures = this.__getFeaturesIdsForFilter(layerId);
        if (isSameContent(currentFeatures, updatedFeatures)) {
            // different amount selected -> notify
            this.__notifySelectionChange(layerId);
        }
        // TODO: on mapmove the selection should be compared for filter
        //   should save the previous selection by filter so we can compare it to new one?
    }
    __getFeaturesIdsForFilter (layerId) {
        let found = false;
        const filter = this._filtersByLayer[layerId];
        if (!filter) {
            // no filter
            return [];
        }
        return this._featureSources.flatMap(source => {
            if (found) {
                return;
            }
            // only search sources if we haven't found it already
            const features = source.getFeatures(layerId);
            if (typeof features !== 'undefined') {
                // source should return undefined in case it doesn't recognize layer
                found = true;
            }
            // TODO: apply filter
            return features; // return id, not feature
        });
    }
    */
    /* ****************************************
     * Notification/events and boilerplate
     * ****************************************
     */
  }, {
    key: "__notifySelectionChange",
    value: function __notifySelectionChange(layerId, previousSelection) {
      var layer = this._sandbox.findMapLayerFromAllAvailable(layerId);
      var selectedFeatureIds = this.getSelectedFeatureIdsByLayer(layerId);
      var build = Oskari.eventBuilder('WFSFeaturesSelectedEvent');
      if (typeof build === 'function') {
        this._sandbox.notifyAll(build(selectedFeatureIds, layer, false));
      }
      this.trigger('change', [layerId, selectedFeatureIds, previousSelection]);
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.__name;
    }
  }, {
    key: "getQName",
    value: function getQName() {
      return QNAME;
    }
    /**
     * @public @method onEvent
     * Event is handled forwarded to correct #eventHandlers if found or
     * discarded* if not.
     *
     * @param {Oskari.mapframework.event.Event} event a Oskari event object
     */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      switch (event.getName()) {
        case 'AfterMapLayerRemoveEvent':
          if (event.getMapLayer().hasFeatureData()) {
            this.removeSelection(event.getMapLayer().getId());
          }
          break;
      }
    }
  }]);
}();
;